import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { UserService } from '@core/services/user.service';
import { environment } from '@environments/environment';

const INTERNAL_API_URLS = [
  environment.apiUrl,
  environment.apiBatchUrl,
];

export const rsNumberInterceptor: HttpInterceptorFn = (request, next) => {
  const currentUser = inject(UserService).getCurrentUser();

  const requestIsToInternalApi = INTERNAL_API_URLS.some(url => request.url.includes(url));
  if (currentUser && requestIsToInternalApi) {
    request = request.clone({
      setHeaders: {
        'X-WSS-rs-user-number': currentUser.loginString,
      },
    });
  }

  return next(request);
};
